import React from 'react';
import parser from 'html-react-parser';

export default function BannerSectionStyle4({
  bgUrl,
  title,
  subTitle,
  center,
}) {
  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-16 pb-16 md:pb-24">
      <div
        className={`relative rounded-md overflow-hidden bg-crimson px-6 py-12 md:p-20 flex flex-col justify-center md:min-h-[320px] ${center ? 'items-center text-center' : 'items-start'}`}
        style={
          bgUrl
            ? {
                backgroundImage: `url(${bgUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }
            : {}
        }
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-crimson/90" />

        {/* Content */}
        <div className="relative z-10 max-w-[780px]">
          <div className={`inline-flex items-center gap-[0.6rem] text-[0.68rem] md:text-[0.72rem] tracking-[0.15em] md:tracking-[0.2em] uppercase text-gold-light font-medium mb-4 md:mb-5 ${center ? 'justify-center' : ''}`}>
            <span className={`w-[24px] h-px bg-gold-light ${center ? 'hidden md:block' : 'block'}`} />
            Noohra Integrated Services
            {center && <span className="w-[24px] h-px bg-gold-light hidden md:block" />}
          </div>

          <h2 className="font-serif text-[1.75rem] md:text-4xl lg:text-[2.8rem] font-light leading-[1.25] text-white mb-4 md:mb-5">
            {parser(title || '')}
          </h2>

          {subTitle && (
            <p className="text-base leading-[1.8] text-white/80 font-light m-0">
              {parser(subTitle)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
